import React, { useContext, useState } from "react"
import SwipeViews from "react-swipeable-views"
import { makeStyles, Theme } from "@material-ui/core/styles"
import Tabs from "@material-ui/core/Tabs"
import Tab from "@material-ui/core/Tab"
import AuthorIcon from "@material-ui/icons/Create"
import ArticleTypeIcon from "@material-ui/icons/Assignment"
import DutyIcon from "@material-ui/icons/AccessAlarm"
import { AppContext } from "../Home/context"

import TabPanel from "./TabPanel"
import { ParameterTab } from "Types/app"

const tabArray: ParameterTab[] = [
    {
        value: "author",
        text: "作者管理",
        icon: <AuthorIcon/>,
        where: {
            hidden: {
                _eq: false
            }
        },
    },
    {
        value: "article_type",
        text: "文章类型",
        icon: <ArticleTypeIcon/>,
    },
    {
        value: "operation_person",
        text: "值班运营",
        icon: <DutyIcon/>,
        where: {
            hidden: {
                _eq: false
            },
            is_species: {
                _eq: false
            }
        },
    },
]

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
    },
    tabIndicator: {
        height: 0,
    },
    tabItem: {
        lineHeight: 1,
        marginTop: 4,
        borderRadius: theme.shape.borderRadius,
        fontSize: 14,
        minHeight: 0,
    },
    selectedItem: {
        backgroundColor: "#ff9800",
        color: "white",
        borderWidth: 0,
    },
}))

export default function Parameter() {
    const classes = useStyles()
    const [ index, setIndex ] = useState(0)
    const { privilegeMap } = useContext(AppContext)
    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setIndex(newValue)
    }
    const handleChangeIndex = (index: number) => {
        setIndex(index)
    }
    return (
        <div className={classes.root}>
            <Tabs
                value={index}
                onChange={handleChange}
                classes={{
                    indicator: classes.tabIndicator,
                }}
                centered
            >
                {
                    tabArray.map((tab: ParameterTab, index) => (
                        <Tab
                            label={tab.text}
                            icon={tab.icon}
                            key={tab.value}
                            value={index}
                            classes={{
                                root: classes.tabItem,
                                selected: classes.selectedItem,
                            }}
                        />
                    ))
                }
            </Tabs>
            <SwipeViews
                index={index}
                onChangeIndex={handleChangeIndex}
            >
                {
                    tabArray.map((tab: ParameterTab, index) => (
                        <TabPanel tab={tab} index={index} key={index} privilegeMap={privilegeMap}/>
                    ))
                }
            </SwipeViews>
            <div id="article_type_modal" />
        </div>
    )
}
